import { useQuery } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import {
  ListMessageAppearanceAcksV2,
  ListMessageAppearanceAcksV2Variables
} from './__generated__/ListMessageAppearanceAcksV2'

export const LIST_MESSAGE_APPEARANCE_ACKS_V2_QUERY = gql`
  query ListMessageAppearanceAcksV2($input: ListMessageAppearanceAcksInputV2!) {
    listMessageAppearanceAcksV2(input: $input) {
      acknowledgments {
        messageAppearanceId
        clientTimestamp
        serverTimestamp
      }
      nextCursor
    }
  }
`

export const useListMessageAppearanceAcksV2 = (
  variables: ListMessageAppearanceAcksV2Variables,
  { skip }: { skip?: boolean } = {}
) => {
  return useQuery<ListMessageAppearanceAcksV2, ListMessageAppearanceAcksV2Variables>(
    LIST_MESSAGE_APPEARANCE_ACKS_V2_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      variables,
      skip
    }
  )
}
